// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__yyE0j","button":"ResetPassword_button__qQBqs","buttonContainer":"ResetPassword_buttonContainer__yuDEE"};